
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d244f0a8!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Disclaimers.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Disclaimers.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-d244f0a8!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Disclaimers.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Disclaimers.vue
// module id = 295
// module chunks = 0